import React from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Grid,
	TextField,
	Switch,
	FormControlLabel,
	Divider,
	Typography,
	CircularProgress,
	Box,
	Paper,
	Avatar,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import LocationOffIcon from "@material-ui/icons/LocationOff";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import EmojiEventsIcon from "@material-ui/icons/EmojiEvents";
import {SettingsFormContent} from "../../../../containers/Profile/Settings/Settings.style";
import RadioGroup from "../../../../components/RadioGroup/RadioGroup";
import AdminRadioCard from "../../../../components/RadioCard/AdminRadioCard";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import CountryCodeSelect from "../../../../components/CountryCode";
import ItemSelected from "../../../admin/ProductsSelection/components/ItemSelected";
import { CURRENCY } from "../../../../helper/constant";
import AutorenewIcon from '@material-ui/icons/Autorenew';

const UpdateCustomerDialog = ({
	                              isOpen,
	                              onClose,
	                              onSubmit,
	                              validated,
	                              formError,
	                              isSubmitting,
	                              editCustom,
	                              username, setUsername,
	                              firstName, setFirstName,
	                              lastName, setLastName,
	                              email, setEmail,
	                              phone, setPhone,
	                              countryCode, setCountryCode,
	                              enableExpress, setEnableExpress,
	                              subscribeStatus, updateSubscriptionStatus,
	                              handleToggleCoupon,
	                              itemListDeliveryAddr,
	                              handleViewMap,
	                              changePrimaryAddress,
	                              isUpdatePrimaryAddressReqeust,
	                              indexPrimaryAddr,
	                              modal,
	                              handleToggle,
	                              setListAddress,
	                              checkFormValidate,
	                              dpBalance, setDpBalance,
	                              dpTierId, setDpTierId,
	                              dpSelectedTier, setDpSelectedTier,
	                              dpGraceTierId, setDpGraceTierId,
	                              dpGraceSelectedTier, setDpGraceSelectedTier,
	                              onViewDelipointTransactions,
								calculateDPTier = false,
								onEvaluateCustomerTier,
                              }) => {
	return (
		<Dialog
			open={isOpen}
			onClose={onClose}
			maxWidth="xl"
			fullWidth
			aria-labelledby="update-customer-dialog"
			style={{zIndex: 1}}
		>
			<DialogTitle id="update-customer-dialog">Update Customer</DialogTitle>
			<DialogContent dividers>
				{editCustom ? (
					<Grid container spacing={3}>
						{/* Left Column: Form */}
						<Grid item xs={12} sm={6}>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<TextField
										fullWidth variant="outlined" label="Username" required
										value={username}
										error={!!formError.username}
										helperText={formError.username && "Username is required."}
										onChange={(e) => setUsername(e.target.value)}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextField
										fullWidth variant="outlined" label="First Name" required
										value={firstName}
										error={!!formError.firstName}
										helperText={formError.firstName && "First name is required."}
										onChange={(e) => setFirstName(e.target.value)}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextField
										fullWidth variant="outlined" label="Last Name" required
										value={lastName}
										error={!!formError.lastName}
										helperText={formError.lastName && "Last name is required."}
										onChange={(e) => setLastName(e.target.value)}
									/>
								</Grid>
								<Grid item xs={12}>
									<TextField
										fullWidth variant="outlined" label="Email" required
										value={email}
										error={!!formError.email}
										helperText={formError.email && "Email is required."}
										onChange={(e) => setEmail(e.target.value)}
									/>
								</Grid>
								<Grid item xs={6}>
									<CountryCodeSelect
										onChange={(option) => setCountryCode(option)}
										value={countryCode}
										placeholder="Country Code"
										name="Country Code"
										error={false}
									/>
								</Grid>
								<Grid item xs={6}>
									<TextField
										fullWidth variant="outlined" label="Phone" required
										value={phone}
										error={!!formError.phone}
										helperText={formError.phone && "Phone is required."}
										onChange={(e) => setPhone(e.target.value)}
									/>
								</Grid>
								<Grid item xs={12}>
									<FormControlLabel
										control={
											<Switch
												checked={enableExpress}
												onChange={() => setEnableExpress(!enableExpress)}
												disabled={isSubmitting}
												color="primary"
											/>
										}
										label="Deli Express"
									/>
								</Grid>
								<Grid item xs={12}>
									<Divider/>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="subtitle1" style={{fontWeight: 600}}>
										Email
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<FormControlLabel
										control={
											<Switch
												checked={subscribeStatus}
												onChange={updateSubscriptionStatus}
												color="primary"
											/>
										}
										label="Receive Marketing Emails"
									/>
								</Grid>
								<Grid item xs={12}>
									<Divider/>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="subtitle1" style={{fontWeight: 600}}>
										Coupon
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Button
										onClick={handleToggleCoupon}
										variant="contained"
										color="primary"
										startIcon={<LocalOfferIcon/>}
										style={{textTransform: "none", fontWeight: 500}}
									>
										Manage Coupon
									</Button>
								</Grid>
							</Grid>
						</Grid>

						{/* Right Column: Delivery Address */}
						<Grid item xs={12} sm={6}>
							<Grid container spacing={2}>
								<Grid item xs={12}>
									<Box display="flex" alignItems="center" gap={1}>
										<Typography variant="h6">Delipoints</Typography>
									</Box>
								</Grid>

								{/* Current Tier Badge */}
								<Grid item xs={5}>
									{editCustom?.delipoints_tier && (
										<Box display="flex" alignItems="center" p={1.5}
											style={{ background: "#fdf6ec", borderRadius: 8, border: "1px solid #f5d88a" }}>
											<Avatar
												src={editCustom.delipoints_tier.image}
												alt={editCustom.delipoints_tier.name}
												style={{ width: 36, height: 36, marginRight: 10 }}
											/>
											<Box>
												<Typography variant="caption" color="textSecondary">Current Tier</Typography>
												<Typography variant="subtitle2" style={{ fontWeight: 700 }}>
													{editCustom.delipoints_tier.name}
												</Typography>
												<Typography variant="caption" color="textSecondary">
													Multiplier: ×{editCustom.delipoints_tier.multiplier}
												</Typography>
											</Box>
											<Box display="flex" justifyContent="center" width="60%" padding={1}>
												<Typography style={{ textAlign: 'center' }}>Order Value {editCustom.total_spend_excl_grace_months} months: {CURRENCY} {editCustom.total_spend_excl_grace}</Typography>
											</Box>
										</Box>
									)}
								</Grid>

								{/* Grace Tier Badge */}
								<Grid item xs={5}>
									{editCustom?.grace_delipoints_tier && (
										<Box display="flex" alignItems="center" p={1.5}
											style={{ background: "#eef6fd", borderRadius: 8, border: "1px solid #a8d4f5" }}>
											<Avatar
												src={editCustom.grace_delipoints_tier.image}
												alt={editCustom.grace_delipoints_tier.name}
												style={{ width: 36, height: 36, marginRight: 10 }}
											/>
											<Box>
												<Typography variant="caption" color="textSecondary">Grace Tier</Typography>
												<Typography variant="subtitle2" style={{ fontWeight: 700 }}>
													{editCustom.grace_delipoints_tier.name}
												</Typography>
												<Typography variant="caption" color="textSecondary">
													Multiplier: ×{editCustom.grace_delipoints_tier.multiplier}
												</Typography>
											</Box>
											<Box display="flex" justifyContent="center" width="60%" padding={1}>
												<Typography style={{ textAlign: 'center' }}>Order Value {editCustom.total_spend_months} months: {CURRENCY} {editCustom.total_spend}</Typography>
											</Box>
										</Box>
									)}
								</Grid>

								<Grid item xs={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'stretch' }}>
									<Button
										variant="contained"
										onClick={onEvaluateCustomerTier}
										disabled={calculateDPTier}
										style={{
											backgroundColor: 'transparent',
											boxShadow: 'none',
											textTransform: 'none',
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
											justifyContent: 'center',
											width: '100%',
											height: '100%',
										}}
									>
									<div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 4}}>
										{calculateDPTier
										? <CircularProgress size={40} style={{ color: '#9e9e9e' }} />
										: <AutorenewIcon style={{ fontSize: 40, color: '#9e9e9e' }} />}
									</div>
									</Button>
								</Grid>

								{/* DP Balance */}
								<Grid item xs={7}>
									<Box mb={3}>
										<TextField
											fullWidth
											variant="outlined"
											label="DP Balance (points)"
											type="number"
											value={dpBalance}
											inputProps={{ min: 0, step: 1 }}
											onChange={(e) => setDpBalance(parseInt(e.target.value, 10))}
										/>
									</Box>
								</Grid>

								{/* View Transactions Button */}
								<Grid item xs={5}>
									<Box mb={3}>
										<Button
											fullWidth
											onClick={onViewDelipointTransactions}
											variant="outlined"
											color="primary"
											startIcon={<EmojiEventsIcon/>}
											style={{textTransform: "none", fontWeight: 500, height: "100%", minHeight: 56}}
										>
											View Delipoint Transactions
										</Button>
									</Box>
								</Grid>

								{/* Tier Selector */}
								{/* <Grid item xs={6}>
									<Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
										Change Tier
									</Typography>
									<ItemSelected
										fieldType="DelipointTier"
										placeholder="Search tier..."
										blockType="entityType"
										singleSelect={true}
										value={dpSelectedTier}
										onchange={(selected) => {
											setDpSelectedTier(selected);
											setDpTierId(selected ? selected.id : null);
										}}
									/>
								</Grid> */}

								{/* Grace Tier Selector */}
								{/* <Grid item xs={6}>
									<Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: 8 }}>
										Change Grace Tier
									</Typography>
									<ItemSelected
										fieldType="DelipointTier"
										placeholder="Search grace tier..."
										blockType="entityType"
										singleSelect={true}
										value={dpGraceSelectedTier}
										onchange={(selected) => {
											setDpGraceSelectedTier(selected);
											setDpGraceTierId(selected ? selected.id : null);
										}}
									/>
								</Grid> */}
								<Grid item xs={12}>
									<Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
										<Typography variant="h6" gutterBottom>
											Delivery Address
										</Typography>
										<Button
											variant="outlined"
											size="small"
											color="primary"
											startIcon={<AddIcon/>}
											onClick={() => handleToggle(null, false)}
											style={{textTransform: "none", fontWeight: 500}}
										>
											Add Address
										</Button>
									</Box>
									<Paper variant="outlined">
										<Box display="flex" flexDirection="column" gap={2}>
											<SettingsFormContent>
												<ButtonGroup orientation="vertical" fullWidth style={{padding: 5}}>
													{itemListDeliveryAddr.length > 0 ? (
														<RadioGroup
															items={itemListDeliveryAddr}
															component={(item, index) => (
																<AdminRadioCard
																	index={index}
																	id={item.address_id}
																	key={item.address_id || item.id}
																	title={item.nick_name}
																	firstName={item.first_name}
																	lastName={item.last_name || null}
																	value={item.address_id}
																	content={item.area_details}
																	house_number={item.house_number}
																	apartment_name={item.apartment_name}
																	street_details={item.street_details}
																	mobile_number={item.mobile_number}
																	country_code={item.country_code}
																	city={item.city}
																	landmark={item.landmark}
																	pin_code={item.pin_code}
																	delivery_instructions={item.delivery_instructions}
																	name="address"
																	checked={item.is_default === 1}
																	isUpdatePrimaryAddressReqeust={isUpdatePrimaryAddressReqeust}
																	indexPrimaryAddr={indexPrimaryAddr}
																	handleOpenMap={() => handleViewMap(item, index)}
																	onChange={() => {
																	}}
																	onEdit={() =>
																		changePrimaryAddress(item.address_id, item.cust_id, index)
																	}
																	modal={modal}
																	handleToggle={() => handleToggle(item, true)}
																	setListAddress={setListAddress}
																	checkFormValidate={checkFormValidate}
																/>
															)}
														/>
													) : (
														<Box
															display="flex"
															flexDirection="column"
															alignItems="center"
															justifyContent="center"
															py={6}
														>
															<LocationOffIcon style={{fontSize: 64, color: "#b0bec5"}}/>
															<Typography variant="h6" align="center" color="textSecondary" gutterBottom>
																No Delivery Address
															</Typography>
															<Typography variant="body2" align="center" color="textSecondary">
																This Customer haven't added any delivery addresses yet.
															</Typography>
															<Box mt={3}>
																<Button
																	variant="contained"
																	color="primary"
																	onClick={() => handleToggle(null, false)}
																>
																	Add New Address
																</Button>
															</Box>
														</Box>
													)}
												</ButtonGroup>
											</SettingsFormContent>
										</Box>
									</Paper>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				) : (
					<Typography align="center">Customer not found.</Typography>
				)}
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose} color="secondary" disabled={isSubmitting}>
					Close
				</Button>
				<Button
					color="primary"
					variant="contained"
					disabled={isSubmitting}
					onClick={onSubmit}
					startIcon={isSubmitting ? <CircularProgress size={18}/> : null}
				>
					Update
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default UpdateCustomerDialog;
